"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_ADMINISTRATOR_ROLE = exports.STAFF_ROLE = exports.PHARMACIST_ROLE = exports.MANAGER_ROLE = exports.CLIENT_ADMINISTRATOR_ROLE = void 0;
exports.isAdministratorRole = isAdministratorRole;
exports.isClientAdministratorRole = isClientAdministratorRole;
exports.isSystemAdministratorRole = isSystemAdministratorRole;
exports.normalizeRole = normalizeRole;
exports.resolveUserRole = resolveUserRole;
var SYSTEM_ADMINISTRATOR_ROLE = "system_administrator";
exports.SYSTEM_ADMINISTRATOR_ROLE = SYSTEM_ADMINISTRATOR_ROLE;
var CLIENT_ADMINISTRATOR_ROLE = "client_administrator";
exports.CLIENT_ADMINISTRATOR_ROLE = CLIENT_ADMINISTRATOR_ROLE;
var MANAGER_ROLE = "manager";
exports.MANAGER_ROLE = MANAGER_ROLE;
var STAFF_ROLE = "staff";
exports.STAFF_ROLE = STAFF_ROLE;
var PHARMACIST_ROLE = "pharmacist";
exports.PHARMACIST_ROLE = PHARMACIST_ROLE;
var SYSTEM_ADMINISTRATOR_ALIASES = new Set(["system_administrator", "system administrator", "superadmin", "super_admin"]);
var CLIENT_ADMINISTRATOR_ALIASES = new Set(["client_administrator", "client administrator", "admin"]);
var STAFF_ALIASES = new Set(["staff", "worker"]);
var PHARMACIST_ALIASES = new Set(["pharmacist"]);
function normalizeRole(role) {
    return (role !== null && role !== void 0 ? role : "").trim().toLowerCase();
}
function resolveUserRole(value) {
    if (typeof value === "object" && value !== null) {
        if (value.is_superadmin === true) {
            return SYSTEM_ADMINISTRATOR_ROLE;
        }
        if (value.is_admin === true) {
            return CLIENT_ADMINISTRATOR_ROLE;
        }
        return resolveUserRole(value.user_role);
    }
    var role = normalizeRole(typeof value === "string" ? value : undefined);
    if (SYSTEM_ADMINISTRATOR_ALIASES.has(role)) {
        return SYSTEM_ADMINISTRATOR_ROLE;
    }
    if (CLIENT_ADMINISTRATOR_ALIASES.has(role)) {
        return CLIENT_ADMINISTRATOR_ROLE;
    }
    if (STAFF_ALIASES.has(role)) {
        return STAFF_ROLE;
    }
    if (PHARMACIST_ALIASES.has(role)) {
        return PHARMACIST_ROLE;
    }
    return role || MANAGER_ROLE;
}
function isSystemAdministratorRole(value) {
    return resolveUserRole(value) === SYSTEM_ADMINISTRATOR_ROLE;
}
function isClientAdministratorRole(value) {
    return resolveUserRole(value) === CLIENT_ADMINISTRATOR_ROLE;
}
function isAdministratorRole(value) {
    var resolvedRole = resolveUserRole(value);
    return resolvedRole === SYSTEM_ADMINISTRATOR_ROLE || resolvedRole === CLIENT_ADMINISTRATOR_ROLE;
}
